/* UKCL Fix: Featured Collection Slideshow Init
 * The theme's lazy section manager isn't initializing Flickity on
 * featured-collection sections. This script loads Flickity from CDN
 * and initializes it directly.
 *
 * Handles both desktop slideshow (data-layout="slideshow") and
 * mobile slideshow (data-mobile-layout="slideshow" with data-layout="grid").
 */
(function() {
  'use strict';

  var MOBILE_BREAKPOINT = 1080;
  var flickityInstances = new Map();

  function initSlideshow(el) {
    if (el.classList.contains('flickity-enabled')) return;

    var flkty = new Flickity(el, {
      autoPlay: false,
      accessibility: true,
      cellAlign: 'left',
      cellSelector: '.productgrid--item',
      groupCells: true,
      pageDots: false,
      contain: true,
      prevNextButtons: true,
      arrowShape: 'M65.29 11.99L27.28 50L65.3 87.99L70.25 83.06L37.19 50L70.26 16.94L65.29 11.99Z'
    });

    var viewport = el.querySelector('.flickity-viewport');
    var slider = el.querySelector('.flickity-slider');
    if (viewport && slider) {
      var wrapper = document.createElement('div');
      wrapper.classList.add('flickity-slider--wrapper');
      viewport.appendChild(wrapper);
      wrapper.appendChild(slider);
    }

    flickityInstances.set(el, flkty);
  }

  function destroySlideshow(el) {
    var flkty = flickityInstances.get(el);
    if (flkty) {
      flkty.destroy();
      flickityInstances.delete(el);
    }
  }

  function isMobile() {
    return window.innerWidth < MOBILE_BREAKPOINT;
  }

  function handleSection(section) {
    var content = section.querySelector('.featured-collection__content');
    if (!content) return;

    var desktopLayout = content.getAttribute('data-layout');
    var mobileLayout = content.getAttribute('data-mobile-layout');

    if (isMobile()) {
      /* On mobile: init slideshow if mobile layout is slideshow */
      if (mobileLayout === 'slideshow') {
        initSlideshow(content);
      } else {
        destroySlideshow(content);
      }
    } else {
      /* On desktop: init slideshow if desktop layout is slideshow */
      if (desktopLayout === 'slideshow') {
        initSlideshow(content);
      } else {
        /* Desktop is grid but mobile was slideshow - destroy if active */
        destroySlideshow(content);
      }
    }
  }

  function handleAllSections() {
    document.querySelectorAll('[data-featured-collection]').forEach(handleSection);
  }

  function setupObserver() {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          handleSection(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '300px' });

    document.querySelectorAll('[data-featured-collection]').forEach(function(section) {
      var content = section.querySelector('.featured-collection__content');
      if (!content) return;

      var desktopLayout = content.getAttribute('data-layout');
      var mobileLayout = content.getAttribute('data-mobile-layout');

      /* Observe if either desktop or mobile needs a slideshow */
      if (desktopLayout === 'slideshow' || mobileLayout === 'slideshow') {
        if (!content.classList.contains('flickity-enabled')) {
          observer.observe(section);
        }
      }
    });

    /* Handle resize: toggle slideshow on/off when crossing breakpoint */
    var lastMobile = isMobile();
    var resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        var nowMobile = isMobile();
        if (nowMobile !== lastMobile) {
          lastMobile = nowMobile;
          handleAllSections();
        }
      }, 250);
    });
  }

  function loadFlickityAndInit() {
    if (typeof Flickity !== 'undefined') {
      setupObserver();
      return;
    }

    var script = document.createElement('script');
    script.src = 'https://unpkg.com/flickity@2/dist/flickity.pkgd.min.js';
    script.onload = function() {
      setupObserver();
    };
    document.head.appendChild(script);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadFlickityAndInit);
  } else {
    loadFlickityAndInit();
  }
})();